// CONSTANTS are all caps.
const NS = "ImageSlider";
const CLS = "imageSlider";
const WG = "." + CLS + "-";

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out src/scripts/loadWg/imageSlider.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'

import {loadImageSliderItem} from '../loadWg/imageSliderItem';

export class ImageSlider {

	constructor($el) {
		// $el is the widget node return by the loadImageSlider function
		this.$el = $el;
	}

	init() {
		this.setImageSlider();
		this.setImageSliderItem();
	}

	setImageSliderItem() {
        loadImageSliderItem(this.$el, true).then((wgAll) => {
			wgAll ? Array.from(wgAll).forEach(wg => {
				wg.init();
			}) : '';
		});
    }

	setImageSlider() {

	    let wg = $(this.$el);
        let circleSlickSlider = wg.find(WG + 'mobileNav');
        let desktopNavItems = wg.find(WG + 'item');
        let slides = wg.find(WG + 'slide');

        let showSlideAtIndex = slideIndex => {
            let thisNavItem = desktopNavItems.eq(slideIndex);
            desktopNavItems.removeClass('active');
            thisNavItem.addClass('active');
            let slideForHide = wg.find(WG + 'slide.active');
            let slideForShow = slides.eq(slideIndex);
            slideForHide.removeClass('active').fadeOut();
            slideForShow.addClass('active').css({'position':'absolute', 'left': 0, 'top': 0, 'width': '100%'}).fadeIn(() => {
                slideForShow.css('position', 'relative');
            });

            circleSlickSlider.slick('slickGoTo', slideIndex);
        }

        circleSlickSlider.slick({
            arrows: true,
            slidesToShow: 4
        });

        desktopNavItems.click((e) => {
            showSlideAtIndex(desktopNavItems.index(e.currentTarget));
        });

        desktopNavItems.eq(0).trigger('click');

        circleSlickSlider.find('.slick-slide').click(e => {
	        let slideIndex = e.currentTarget.getAttribute('data-slick-index');
	        showSlideAtIndex(slideIndex);
        });
	}
}
